"use client";

import { useCallback, useEffect, useState, useSyncExternalStore } from "react";
import styles from "../mojumoncrimson.module.css";

/** Prototype class names kept verbatim (kebab-case), mapped through the CSS module. */
export const c = (...names: Array<string | false | null | undefined>) =>
  names.filter(Boolean).map((n) => styles[n as string] ?? n).join(" ");

export function useReducedMotion() {
  const q = "(prefers-reduced-motion: reduce)";
  const subscribe = useCallback((fn: () => void) => { const mq = window.matchMedia(q); mq.addEventListener("change", fn); return () => mq.removeEventListener("change", fn); }, []);
  return useSyncExternalStore(subscribe, () => window.matchMedia(q).matches, () => false);
}

/**
 * Prototype's typeProfessor(): 24 ms per character, caret while typing.
 * `key` forces a retype of the same text (e.g. the same fact twice in a row can't
 * happen, but a held line can repeat).
 */
export function useTypewriter(text: string, key: number, reducedMotion: boolean) {
  const [shown, setShown] = useState<{ key: number; n: number }>({ key: -1, n: 0 });
  useEffect(() => {
    if (reducedMotion) { const t = window.setTimeout(() => setShown({ key, n: text.length }), 0); return () => window.clearTimeout(t); }
    let i = 0;
    const id = window.setInterval(() => { i += 1; setShown({ key, n: i }); if (i >= text.length) window.clearInterval(id); }, 24);
    return () => window.clearInterval(id);
  }, [text, key, reducedMotion]);
  const n = shown.key === key ? shown.n : 0;
  return { visible: text.slice(0, n), typing: n < text.length };
}
